import { S as Swiper } from './index-Cj6iU7wg.js';
import './swiper-core-kdoF3145.js';
import './classes-to-selector-JYvn0qt6.js';

class AnnouncementBar extends HTMLElement {
  autoplay = this.dataset.autoplay === 'true';
  autoplayDelay = this.dataset.autoplayDelay;
  modules = [];

  async connectedCallback() {
    await this.loadModules();
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = Swiper(this, {
      modules: this.modules,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      autoplay: {
        enabled: this.autoplay,
        delay: this.autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });
  }

  async loadModules() {
    const { Autoplay } = await import('./index-DHebtvlb.js');
    this.modules.push(Autoplay);
  }
}

customElements.define('announcement-bar', AnnouncementBar);
